export default __webpack_public_path__ + "static/media/domainSample.f5e906f8.csv";